export const TEXT_TYPES = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
};
